import { StyleSheet, TextInput, Platform, LayoutChangeEvent, NativeSyntheticEvent, TextInputFocusEventData, } from 'react-native'
import { useTheme } from "@/hooks/useTheme";


interface IsEditingProps {
    inputType: any,
    inputRef: { readonly current: TextInput | null },
    isValid: boolean,
    localValue: any
    editable: boolean
    handleFocus: (e: NativeSyntheticEvent<TextInputFocusEventData>) => void
    handleChangeText: (s: string) => void
    handleBlur: (e?: NativeSyntheticEvent<TextInputFocusEventData> | undefined) => void
    handleTextLayout: (event: LayoutChangeEvent) => void
}
/* 
* Text input Cell when cell is being actively edited. 
*/
export const IsEditingCell = ({ inputType, inputRef, localValue, isValid, editable, handleFocus, handleChangeText, handleBlur, handleTextLayout }: IsEditingProps) => {
    const { colors } = useTheme();
    return (
        <TextInput
            onLayout={handleTextLayout}
            ref={inputRef}
            style={[
                styles.input,
                { color: colors.text, width: "100%" },
                !isValid && { color: colors.red.text, width: "100%" },
            ]}
            value={localValue}
            editable={
                editable &&
                (typeof inputType === "string" || (inputType?.type !== "enum" && inputType?.type !== "array"))
            } // Prevent typing in enum/array fields
            onFocus={handleFocus}
            autoFocus={true}
            selectTextOnFocus={true}
            onChangeText={handleChangeText}
            onBlur={handleBlur}
        />
    )
}

const styles = StyleSheet.create({
    input: {
        top: -2,
        position: "absolute",
        fontSize: 16,
        borderRadius: 8,
        paddingHorizontal: 4,
        height: 28,
        ...(Platform.OS === "web" ? { outlineStyle: "none" } : {}),
    },
});
